<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if(piece && isMaxiLogoEnabled()){
    <idt-common-styles-render
    [styles]="piece.settings?.styles">
        @let orientation = orientation$ | async;
        @if(!!settings) {
            @if (orientation === 'landscape') {
                @let lazySrc = getLandscapeImageSrc();
                <img
                alt=""
                [lazySrc]="lazySrc"
                [preRender]="!!settings.general.preloadImage"/>
            } @else {
                @let lazySrc = getPortraitImageSrc();
                <img
                alt=""
                [lazySrc]="lazySrc"
                [preRender]="!!settings.general.preloadImage">
            }
        }
    </idt-common-styles-render>
}
